import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const SectorGuard = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '1.2rem'
      }}>
        Loading...
      </div>
    );
  }

  const hasSchool = Boolean(user?.entityId);
  if (!hasSchool) {
    return (
      <div style={{ maxWidth: 720, margin: '120px auto', padding: '0 16px', textAlign: 'center' }}>
        <h1 style={{ fontSize: 28, marginBottom: 12 }}>School Access Required</h1>
        <p style={{ color: '#666', marginBottom: 24 }}>
          Your account is not associated with a school yet. Please contact the admin to gain access
          to this page.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/profile', { state: { from: location } })}
            style={{ padding: '10px 16px', borderRadius: 8, border: '1px solid #ccc', cursor: 'pointer' }}
          >
            Go to Profile
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            style={{ padding: '10px 16px', borderRadius: 8, border: '1px solid #ccc', cursor: 'pointer' }}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default SectorGuard;


